import React from 'react';
import { SectionHeading } from '../components/ui/SectionHeading';
import { ScrollReveal } from '../components/ui/ScrollReveal';
export function AboutPage() {
  return <div className="w-full pt-24 bg-brand-cream-light" data-id="element-454">
      <section className="py-24 max-w-4xl mx-auto px-6 text-center" data-id="element-455">
        <SectionHeading eyebrow="Our Story" title="The evolution of the putting experience." align="center" data-id="element-456" />
      </section>

      <section className="py-16 max-w-3xl mx-auto px-6" data-id="element-457">
        <ScrollReveal data-id="element-458">
          <div className="prose prose-lg prose-headings:font-heading prose-headings:text-brand-green-deep prose-p:font-body prose-p:text-brand-stone max-w-none" data-id="element-459">
            <h3 className="text-3xl mb-6" data-id="element-460">The TurfsUp! Legacy</h3>
            <p className="mb-12" data-id="element-461">
              PuttLab was born from TurfsUp!, a company with nearly a decade of
              experience and over 1000+ completed projects in North America. We
              spent years mastering the craft of synthetic turf installation,
              learning exactly how materials perform, how contours affect roll,
              and what it takes to build a green that lasts.
            </p>

            <h3 className="text-3xl mb-6" data-id="element-462">Why PuttLab Now</h3>
            <p className="mb-12" data-id="element-463">
              As our expertise grew, so did the ambition of our clients. They
              didn't just want a patch of turf; they wanted an architectural
              feature. They wanted a social hub. They wanted an experience.
              PuttLab was created to serve this premium tier—focusing entirely
              on design-led, luxury golf environments for homes, resorts, and
              developers.
            </p>

            <h3 className="text-3xl mb-6" data-id="element-464">Vision for the Future</h3>
            <p className="mb-12" data-id="element-465">
              We believe the future of golf isn't just on the 18-hole course.
              It's in the backyard, on the rooftop, and at the resort. By
              combining premium craftsmanship with digital layers like PuttLab
              Play, we are redefining what a putting green can be.
            </p>
          </div>
        </ScrollReveal>
      </section>
    </div>;
}